import _Container from './Container';

import './style/index.js';

export * from './type';

export const Container = _Container;

export default Container;
